module.exports = __webpack_public_path__ + "img/y4pt.00eb4b88.png";